import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class WxService {
  constructor() {}

  // 二维码
  authQrcode(state: string) {
    const appid = environment.wxappid;
    const rurl = encodeURIComponent(environment.wxauthurl);
    return `https://open.weixin.qq.com/connect/qrconnect?appid=${appid}&redirect_uri=${rurl}&response_type=code&scope=snsapi_login&state=${state}#wechat_redirect`;
  }

  isInWechat() {
    return /MicroMessenger/i.test(window.navigator.userAgent);
  }

  /* 打开客服 */
  openKF() {
    window.location.href =
      'https://work.weixin.qq.com/kfid/kfc47379dea01203d54';
  }
}
